import API from "../api";
import { TokenService } from "@/api/storage";
import { initialize } from "@/api";
import {
  UserToken,
  PayloadAuth,
  PayloadOnboarding,
  PayloadLogin,
  PayloadEmail,
} from "../types";
import { Commit, Dispatch } from "vuex";
import { PayloadInvalidateToken } from "@/types";
export default {
  namespaced: true,
  state: {
    loginUser: {
      email: "",
      senha: "",
    },
  },
  mutations: {
    setLoginUser(state: any, payload: PayloadLogin) {
      state.loginUser = payload;
    },
  },
  actions: {
    storeToken({ dispatch }: { dispatch: Dispatch }, payload: UserToken): void {
      const payloadInvalidateToken: PayloadInvalidateToken = {
        jwtToken: TokenService.getToken(),
        refreshToken: TokenService.getRefreshToken(),
      };
      TokenService.removeToken();
      TokenService.removeRefreshToken();
      TokenService.saveToken(JSON.stringify(payload.token));
      if (payload.refreshToken) {
        TokenService.saveRefreshToken(JSON.stringify(payload.refreshToken));
      }
      if (payloadInvalidateToken.refreshToken) {
        dispatch("requestInvalidateToken", payloadInvalidateToken);
      }
      initialize();
    },
    storeTokenUrl(context: any, payload: string): void {
      TokenService.removeToken();
      TokenService.removeRefreshToken();
      TokenService.saveToken(JSON.stringify(payload));
      initialize();
    },
    async requestLoginAuth(
      { dispatch }: { dispatch: Dispatch },
      payload: PayloadAuth
    ): Promise<UserToken> {
      const { data } = await API.getToken(payload);
      dispatch("storeToken", data);
      return data;
    },
    async requestLogin(
      { dispatch }: { dispatch: Dispatch },
      payload: PayloadOnboarding
    ): Promise<UserToken> {
      const { data } = await API.getTokenUser(payload);
      dispatch("storeToken", data);
      return data;
    },
    initializeAxios(): void {
      initialize();
    },
    async requestAuth(
      { dispatch }: { dispatch: Dispatch },
      payload: PayloadLogin
    ): Promise<UserToken> {
      const { data } = await API.getLogin(payload);
      dispatch("storeToken", data);
      dispatch("updateLogin", payload);
      return data;
    },
    async requestRecoverPassword(
      context: any,
      payload: PayloadEmail
    ): Promise<any> {
      const { data } = await API.postRecoverPassword(payload);
      return data;
    },
    updateLogin({ commit }: { commit: Commit }, payload: PayloadLogin): any {
      commit("setLoginUser", payload);
    },
    async requestNewToken({
      dispatch,
    }: {
      dispatch: Dispatch;
    }): Promise<UserToken> {
      const refreshToken = String(TokenService.getRefreshToken());
      const payload = {
        refreshToken: refreshToken,
      };
      const { data } = await API.patchNewTokenUser(payload);
      dispatch("storeToken", data);
      return data;
    },
    async requestInvalidateToken(
      context: any,
      payload: PayloadInvalidateToken
    ): Promise<any> {
      const { data } = await API.patchInvalidateToken(payload);
      return data;
    },
    async requestLogout(
      { dispatch }: { dispatch: Dispatch },
      payload = true
    ): Promise<void> {
      if (payload) {
        const payloadInvalidateToken: PayloadInvalidateToken = {
          jwtToken: TokenService.getToken(),
          refreshToken: TokenService.getRefreshToken(),
        };
        await dispatch("requestInvalidateToken", payloadInvalidateToken);
      }
      TokenService.removeToken();
      TokenService.removeRefreshToken();
      TokenService.removeFirstAccess();
      TokenService.removeIsAcceptTerm();
      TokenService.removeRole();
    },
  },
  modules: {},
};
